import { toast } from 'react-toastify'
import ContactModal, {
  ContactDefaultValues,
} from './ContactModal/MobileContactModal'
import apiService from '../../services/api'
import { ContactResponse } from '../../models/contacts'
import { ContactCompany } from 'models/companies'

export default function EditContactModal({
  show,
  handleClose,
  onContactUpdated,
  contact,
  forCompany,
  initialDoorIds,
}: {
  show: boolean
  handleClose: () => void
  onContactUpdated?: () => void
  contact: ContactResponse
  forCompany?: Partial<ContactCompany>
  initialDoorIds?: number[]
}) {
  const api = apiService()

  const handleSubmitSuccess = () => {
    toast.success('Contact updated successfully')
    onContactUpdated?.()
    handleClose()
  }

  const updateContact = (values: ContactDefaultValues) => {
    return api.updateContact(contact.id, {
      ...values,
      contact_company: {
        ...values.contact_company,
        domain: values.company_domain, // Move company_domain to company object so we override it on the backend if needed
      },
    })
  }

  const { data: contactDetails } = api.useGetContactDetails(contact.id)

  return ContactModal({
    show,
    handleClose,
    onSubmitSuccess: handleSubmitSuccess,
    confirmButtonText: 'Update',
    submitApiAction: updateContact,
    contactToEdit: contact,
    initialDoorIds: contactDetails?.door_ids || initialDoorIds,
    forCompany,
  })
}
